// Font utility functions

export const FONTS = {
  RUBIK: 'Rubik',
  NOTO_SANS_HEBREW: 'Noto Sans Hebrew'
};

export const getFontFromQueryParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fontParam = urlParams.get('font');
  
  if (fontParam === 'NotoSansHebrew') {
    return FONTS.NOTO_SANS_HEBREW;
  }
  
  return FONTS.RUBIK;
};

export const updateCSSFontVariable = (font) => {
  const root = document.documentElement;
  root.style.setProperty('--app-font-family', `'${font}'`);
}; 